import { ROUTE_POLICIES, ROUTE_POLICY_EDIT } from '@/router/routes/routeNames'

const Policies = () => import('@/components/policies/PoliciesView.vue')
// Bridge: picks the old or the new edit view. Goes with src/legacy — see
// src/legacy/policies/README.md.
const PolicyEdit = () => import('@/legacy/policies/PolicyEditRouteView.vue')

const policiesRoutes = [
  {
    name: ROUTE_POLICIES,
    path: '/policies',
    component: Policies,
    meta: { resource: 'Policies' },
  },
  // The old create wizard's URL, which would otherwise open "create" as a policy id
  { path: '/policies/create', redirect: { name: ROUTE_POLICIES } },
  {
    name: ROUTE_POLICY_EDIT,
    path: '/policies/:policyId',
    props: true,
    component: PolicyEdit,
    meta: { resource: 'Policies' },
  },
]

export default policiesRoutes
